import {MuNamedWidgets, MuWidget} from "mu-widget/lib/MuWidget";
import {UiFlashContainer, UiFlashItem} from "mu-widget/lib/components/UiFlash";
import {CheckboxList} from "mu-widget/lib/components/InputList";
import { frontAppConfig } from "../../FrontAppConfig";
import {WebPush} from "../../WebPush";
import {serverConfig} from "../../ServerConfig";
import {AppTL} from "../../gen/tl";

export class UiNotifyBanner extends MuWidget
{
    // @ts-ignore
    public flashMessage : UiFlashItem;

    //@ts-ignore
    muNamedWidget: MuNamedWidgets<{
        notifyTypes: CheckboxList,
    }>;

    beforeIndex() {
        this.muAppendContent(`
            <div mu="pOptions">
                <p>Chceš dostávat upozornění?</p>
                <div mu="notifyTypes:CheckboxList"></div>
                <div class="buttons">
                    <span mu="bEnable" class="btn--primary">Ano</span>
                    <span mu="bDisable" class="btn--secondary">Ne</span>
                    <span mu="bLater" class="btn--secondary">Později</span>
                </div>
            </div>
            <div mu="pConfirmInfo">
                <p>Teď povol notifikace ve svém prohlížeči / mobilu.</p>
            </div>
        `)
    }

    public static openDialog(): void {
        const flash = UiFlashContainer.add('');
        flash.closeTimer.stop();
        flash.muCreateWidget<UiNotifyBanner>(
            'UiNotifyBanner',
            'message',
            { flashMessage: flash },
        );
    }

    protected static isNotifyAllowed(): boolean {
        return Notification.permission === 'granted';
    }

    public static async openDialogIfNeeded(): Promise<void> {
        await frontAppConfig.ready;
        const wps = await (await this.webPush()).current();
        if (
            frontAppConfig.notify === null
            || (frontAppConfig.notify && (!this.isNotifyAllowed() || !wps))
        ) {
            this.openDialog();
        } else if (wps && frontAppConfig.notify) {
            // aktualizace pro jistotu
            await (new AppTL()).saveWebPushSubscription(wps, frontAppConfig.subscriptionConfig());
        }
    }

    /* private static async isSyncAllowed() {
        const syncAllowed = (await navigator.permissions.query({
            name: 'background-sync', // 'periodic-background-sync'
        })).state === 'granted';
        return syncAllowed;
    } */

    async afterIndex() {
        this.muNamedWidget.notifyTypes.setOptions([
            { value: 'plan', text: 'Položky plánu', },
            { value: 'note', text: 'Komentáře trenéra', },
            // { value: 'watch', text: 'Sledování aktivity', }
        ]);
        await frontAppConfig.ready;
        this.muNamedWidget.notifyTypes.value = frontAppConfig.notifyTypes;
        this.muVisible(false, 'pConfirmInfo');
    }

    bEnable_click() {
        this.saveConfig(true);
    }

    bDisable_click() {
        this.saveConfig(false);
    }

    bLater_click() {
        this.flashMessage.close_click();
    }

    async saveConfig(notify: boolean|null) {
        await frontAppConfig.ready;
        frontAppConfig.notify = notify;
        // @ts-ignore
        frontAppConfig.notifyTypes = this.muNamedWidget.notifyTypes.value;
        await frontAppConfig.saveConfig();
        //todo: aktivovat web push jen pokud je povoleno notify, v případě vypnutí zrušit subscription
        if (notify) {
            switch (Notification.permission) {
                case 'default':
                    this.muVisible(
                        true,
                        [ '!pOptions', 'pConfirmInfo' ]
                    );
                    if (await Notification.requestPermission() === 'granted'/* && await this.requestSync()*/) {
                        UiFlashContainer.add('Uloženo a nastaveno');
                    } else {
                        UiFlashContainer.add('Nenastaveno');
                    }
                    break;
            }
            await this.registerWebPush();
        } else {
            UiFlashContainer.add('Nastevní uloženo');
        }
        await this.flashMessage.close_click();
    }

    /* private async requestSync() {
        try {
            const registration = await navigator.serviceWorker.ready;
            await registration.periodicSync.register('tick', {
                minInterval: 60 * 1000, // 24 hodin
            });
            console.log('Periodic background sync "my-content-sync" úspěšně zaregistrován.');
        } catch (err) {
            console.error('Chyba při registraci periodic background sync:', err.name, err.message);
            if (err.name === 'NotAllowedError') {
                console.warn('Registrace zamítnuta. Uživatel buď zamítl oprávnění, nebo prohlížeč neudělil dostatečné site engagement skóre.');
            }
        }
    } */
    private static async webPush() {
        return new WebPush(
            await navigator.serviceWorker.ready,
            serverConfig.webPushPublicKey,
        );
    }

    private async registerWebPush() {
        const webPush = await UiNotifyBanner.webPush();
        const subscription = await webPush.current() ?? await webPush.register();
        // console.log('subscription', subscription);
        await frontAppConfig.ready;
        await (new AppTL()).saveWebPushSubscription(subscription, frontAppConfig.subscriptionConfig());
    }
}